export default __webpack_public_path__ + "static/media/five.d01c7593.jpg";